import { getItemMaker } from "./tools";

const i = getItemMaker("pendants");
export const pendants = [
  i("Little Wooden Katana"),
  i("Sleek Shank", "EquipmentPendant10"),
  i("Crescent Moon Pendant"),
  i("Deathbloom Flower Pendant", "EquipmentPendant31"),
  i("Carrot Horror", "EquipmentPendant11"),
  i("Strung Bludgeon"),
  i("Tarantulight", "EquipmentPendant12"),
  i("Cedar Pendant", "EquipmentPendant19"),
  i("Chaotic Amarok Pendant", "EquipmentPendant17"),
  i("Polished Bludgeon", "EquipmentPendant26"),
  i("Fishhead Pendant"),
  i("Skullfish Pendant"),
  i("Fuscismatia"),
  i("Deathly Cluster Pendant"),
  i("Chizoars Blankie", "EquipmentPendant24"),
  i("Hallowed Tail Pendant"),
  i("Chizoars Caustic Scarf", "EquipmentPendant25"),
  i("Persephones Bouquet"),
  i("Strung Tooth of the Divine"),
  i("The Divine Scarf"),
  i("Slimy Necklace", "EquipmentPendant32"),
];
